export default __webpack_public_path__ + "static/media/tech-advisor.6902aae1.png";